import { render } from "./AboutMeList.vue?vue&type=template&id=01dfa196"
import script from "./AboutMeList.vue?vue&type=script&lang=js"
export * from "./AboutMeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__